/**
 * @generated SignedSource<<ccfbad4c0f60d5bd3f54f180fea3262a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useApplySmartFolderSubTypeChangeContentWriteFragment$data = {
  readonly id: string | null | undefined;
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "useApplySmartFolderSubTypeChangeContentWriteFragment";
};
export type useApplySmartFolderSubTypeChangeContentWriteFragment$key = {
  readonly " $data"?: useApplySmartFolderSubTypeChangeContentWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useApplySmartFolderSubTypeChangeContentWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useApplySmartFolderSubTypeChangeContentWriteFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "Content"
};

(node as any).hash = "7b1e91c800d1490b419afc4c6e95fb79";

export default node;
